import basketUtils from 'utils/Basket';
import localeUtils from 'utils/LanguageLocale';

/**
 * Calculates the savings between two formatted price strings.
 * Uses Math.round to avoid floating-point drift (e.g. 57.40 - 45.00 = 12.399...).
 * Output format matches the current locale: '$12.40' (US/CA EN) or '144,00 $' (FR CA).
 *
 * @param {string|null|undefined} originalPrice - Pre-discount price, e.g. '$57.40' or '1 040,00 $'
 * @param {string|null|undefined} salePrice - Discounted price, e.g. '$45.00' or '896,00 $'
 * @returns {string|null} Formatted savings, or null when no savings exist
 */
function calculatePriceSavings(originalPrice, salePrice) {
    if (!originalPrice || !salePrice) {
        return null;
    }

    const originalAmount = parseFloat(basketUtils.removeCurrency(originalPrice));
    const saleAmount = parseFloat(basketUtils.removeCurrency(salePrice));

    if (isNaN(originalAmount) || isNaN(saleAmount) || originalAmount <= saleAmount) {
        return null;
    }

    const savings = Math.round((originalAmount - saleAmount) * 100) / 100;

    return localeUtils.getFormattedPrice(savings);
}

export { calculatePriceSavings };
